import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Funciona si soy irregular?',
    answer: 'Sí. El método te enseña a identificar las señales biológicas de tu cuerpo para saber en qué fase estás sin importar el calendario. No necesitas un ciclo perfecto de 28 días.'
  }, {
    question: '¿Funciona si tengo SOP, tiroides o estoy en perimenopausia?',
    answer: 'Sí. El sistema está diseñado específicamente para mujeres con ciclos irregulares o condiciones hormonales. El enfoque no es el calendario sino las señales reales de tu cuerpo.'
  }, {
    question: '¿Cuánto tiempo al día necesito dedicarle?',
    answer: 'Menos de 10 minutos al día. La guía está diseñada para mujeres ocupadas. Sin rituales complicados, sin recetas de 2 horas, sin rutinas de gym de 90 minutos.'
  }, {
    question: '¿Es apto para cualquier tipo de dieta?',
    answer: 'El recetario incluye opciones y sustituciones para vegetarianas, veganas y omnívoras. Todo con ingredientes accesibles y sin suplementos caros.'
  }, {
    question: '¿Necesito comprar suplementos?',
    answer: 'No. Nos enfocamos en nutrición real y ajustes de estilo de vida que puedes implementar hoy mismo con lo que ya tienes en casa.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Inmediatamente después del pago, recibirás un correo electrónico con los enlaces de descarga. Acceso de por vida desde tu móvil, tablet o computadora.'
  }, {
    question: '¿Es un pago mensual o recurrente?',
    answer: 'No. Es un pago único de $14.99 USD que te da acceso de por vida a la guía completa y todos los bonos incluidos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-32 bg-white" data-id="element-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-charcoal mb-4" data-id="element-27">
            Preguntas Frecuentes
          </h2>
          <p className="text-deep-charcoal/70" data-id="element-28">
            Resolvemos tus dudas antes de empezar
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-cream-white rounded-2xl overflow-hidden bg-cream-white/30" data-id="element-30">
              <button onClick={() => toggleFAQ(index)} className="w-full px-4 py-4 md:px-6 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-31">
                <span className="font-bold text-deep-charcoal text-base md:text-lg" data-id="element-32">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-dusty-rose transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-33" />
              </button>

              <AnimatePresence data-id="element-34">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-35">
                    <div className="px-6 pb-5 text-deep-charcoal/80 leading-relaxed" data-id="element-36">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}